import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=1a56fb9a&scoped=true&"
import script from "./SingleNotification.vue?vue&type=script&lang=js&"
export * from "./SingleNotification.vue?vue&type=script&lang=js&"
import style0 from "./SingleNotification.vue?vue&type=style&index=0&id=1a56fb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56fb9a",
  null
  
)

export default component.exports